<template>
  <v-app-bar id="app-bar" app flat heigth="75" color="app_bar_color">
    <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom></v-progress-linear>

    <v-btn class="mr-3" outlined color="app_bar_text_color" fab small @click="setDrawer(!drawer)">
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-btn class="mr-3" outlined fab color="app_bar_text_color" small @click="returnBack()">
      <v-icon>mdi-keyboard-backspace</v-icon>
    </v-btn>
    <BreadCrumbs />
    <v-spacer></v-spacer>
    <v-btn icon id="mode-switcher" @click="toggleMode(!isDark)">
      <v-icon color="app_bar_text_color">
        {{ isDark ? 'mdi-weather-sunny' : 'mdi-weather-night' }}
      </v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'
  import BreadCrumbs from './BreadCrumbs'

  export default {
    name: 'AppBar',
    computed: {
      ...mapState(['drawer', 'loading', 'isDark']),
    },
    components: { BreadCrumbs },
    mounted() {
      this.toggleMode(this.isDark)
    },
    methods: {
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
        setDarkMode: 'setIsDark',
        setBreadcrumbs: 'setBreadcrumbs',
      }),

      toggleMode(isDark) {
        this.$vuetify.theme.dark = isDark
        this.setDarkMode(isDark)
      },
      returnBack() {
        this.setBreadcrumbs([])
        this.$router.back()
      },
    },
  }
</script>
